import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import BlockField from './components/BlockField';
import ProfileFiled from './components/ProfileFiled';
import BlockStatus from './components/BlockStatus';
import WriteMessageStatus from './components/WriteMessageStatus'

var Profile = React.createClass({
  handlerChangeStatus: function(data){
    if(data == 5){
      this.handlerChangeMessageStatus(5)
    }else{
      this.setState({status: data, writeMessageStatus: true});
    }
  },
  handlerChangeMessageStatus: function(data, failureStatusId){
    var obj = {sfid: this.props.profile.sfid, status: this.state.status, login: this.props.login, pass: this.props.pass};
    if(data){
      obj.message = data;
    }else if(failureStatusId){
      obj.failureStatusId = failureStatusId;
    }else{
      this.setState({writeMessageStatus: false})
      // alert('Не удалось изменить статус! Оповестите куратора...');
      
      return;
    }
    var THIS = this;
    io.socket.post("/api/changeStatus", obj, function (response){
      if(response && response.success){
        // console.log(response);
        THIS.setState({writeMessageStatus: false})
        THIS.props.actionChangeStatus(THIS.state.status, response.historyStatus, response.new1Cstatus)
      }else{
        THIS.setState({writeMessageStatusError: true})
      }
    });
  },
  handlerOpenPhoto: function(){
    this.setState({openPhoto: !this.state.openPhoto})
  },
  getInitialState: function(){
    return({writeMessageStatus: false, openPhoto: false, writeMessageStatusError: false, status: ''})
  },
  callTomaster: function(){
    var obj = {sfid: this.props.profile.sfid, login: this.props.login, pass: this.props.pass};
    var status = confirm('Вы точно хотите позвонить?')
    if(status){
      io.socket.post("/api/callToMaster", obj, function (response){
        if(response && response.success){
          alert('Ожидайте звонка!')
        }else{
          alert('Не удалось дозвониться!')
        }
      })
    }
  },
  closeChangeMessageStatus: function(){
    this.setState({writeMessageStatus: false})
  },
  render: function(){
    var profile = this.props.profile;
    if(this.state.writeMessageStatus){
      // console.log('writeMessageStatus');
      return(
        <WriteMessageStatus closeChangeMessageStatus={this.closeChangeMessageStatus} status={this.props.profile.status1C} failureStatuses={this.props.failureStatuses} error={this.state.writeMessageStatusError} actionChangeMessageStatus={this.handlerChangeMessageStatus} />
      );
    }else if(this.state.openPhoto){
      return(
        <div className="Profile">
          <div className="photoWrapper open" onClick={this.handlerOpenPhoto}>
            <div className="photo">
            <img src={profile.photo} className="image" />
            <img src={profile.photo2} className="image" />
            <img src={profile.photo3} className="image" />
            <video src={profile.selfiePasportVideo} autoPlay loop poster={profile.photo3} className="image" />
            </div>
          </div>
        </div>
      )
    }else if(typeof profile != 'undefined'){
      var status = this.props.profile.status,
          status1C = this.props.profile.status1C,
          statusText = 'Не добавлен в 1С';
      if(status1C){
        if(status1C == '0'){
          status = true;
          statusText = 'Ожидает обработки';
        }else if(status1C == '1'){
          status = 0;
          statusText = 'В обработке';
        }else if(status1C == '2'){
          status = 3;
          statusText = 'Принят на работу';
        }else if(status1C == '3'){
          status = false;
          statusText = 'Отказано';
        }
      }else{
        if(status === true || status === 'true' || status === 1 || status === '1'){
          status = true;
          // statusText = 'Успех';
        }else if(status === false || status == 'false' || status === 2 || status === '2'){
          status = false;
          // statusText = 'Отказ';
        }else if(status === 3 || status === '3'){
          status = 3;
          // statusText = 'Работает';
        }else if(status === 4 || status === '4'){
          status = 4;
          // statusText = 'Уволен';
        }else if(status == '5'){
          status = 5;
          // statusText = 'Не добавлен в 1С';
        }else{
          status = 0;
          statusText = '';
        }
      }

      var date = new Date(profile.createdAt),
          getRefactDate = (a) => {
              if((a + '').length == 1){
                  return '0' + a;
              }
              return a;
          },
          stringDate = `${getRefactDate(date.getHours())}:${getRefactDate(date.getMinutes())}, ${getRefactDate(date.getDate())}.${getRefactDate(date.getMonth()+1)}.${date.getFullYear()}`,
          askerId;

      if(profile.categoriesTest && profile.categoriesTest.skills){
        profile.categoriesTest.skills.forEach(function(item){
          if(item.typeSkill == 2){
            askerId = item.id;
          }
        })
      }

      return(
        <div className="Profile">
            {profile.photo ? (
                <div className="photoWrapper" onClick={this.handlerOpenPhoto}>
                  <div className="photo"><img src={profile.photo} className="image" /></div>
                  <div className="data"></div>
                </div>
            ) : null}
            <BlockField style={!profile.photo ? {marginTop: 20} : false} type="uniteField" data={profile.specialty} />
            <BlockField type="uniteField" data={`${profile.secondtName} ${profile.firstName} ${profile.middleName || ''}`} />
            {/* <ProfileFiled profile={profile}/> */}
            {profile.numberPhone ? (
              <BlockField typeLink="native" link={"tel:" + (typeof profile.numberPhone != 'undefined' ? profile.numberPhone.replace(/ /g, '') : '')} name="телефон" data={profile.numberPhone} />
            ) : (
              <BlockField style={{cursor: 'pointer', border: '2px solid #4444ef', color: '#2d2d8c'}} name="телефон" data={'Позвонить'} onClick={this.callTomaster} />
            )}
            <BlockField name="Дата" data={stringDate} />
            <BlockField name="email" data={profile.EMail} />
            <BlockField name="город" data={profile.city} />
            <BlockField name="улица" data={profile.street} />
            <BlockField name="номер дома" data={profile.numberHouse} />
            <BlockField name="корпус дома" data={profile.corpusHouse} />
            <BlockField name="подъезд" data={profile.entranceHouse} />
            <BlockField name="этаж" data={profile.floor} />
            <BlockField name="номер квартиры" data={profile.numberApartment} />
            <BlockField name="гражданство" data={profile.country} />
            <BlockField name="серия и номер паспорта" data={profile.numberPasport} />
            <BlockField name="дата рождения" data={profile.birthtday} />
            <BlockField name="пол" data={profile.gender == 'МУЖ' ? 'Мужской' : profile.gender == 'ЖЕН' ? 'Женский' : ''} />
            <BlockField name="наличие автомобиля" data={profile.car} />
            <BlockField name="категория прав" data={profile.categoryCar} />
            {/* <BlockField name="прошлый средний зароботок за 6 месяцев" data={profile.lastMoney} />
            <BlockField name="планируемый заработок на 6 месяцев" data={profile.futureMoney} /> */}
            {/* <BlockField name="прошлая работа" data={profile.lastNameOfWork} />
            <BlockField name="имя рекомендателя" data={profile.recomendFirstName} />
            <BlockField name="отчество рекомендателя" data={profile.recomendMiddleName} /> */}
            {/* {profile.recomendNumberPhone ? (<BlockField typeLink="native" link={"tel:" + profile.recomendNumberPhone.replace(/ /g, '')} name="телефон рекомендателя" data={profile.recomendNumberPhone} />) : null} */}
            <BlockField name="информация о нас" data={profile.infoAboutName || profile.infoAbout} />
            <BlockField name="статус" data={statusText} />
            <BlockField name="ИД сотрудника" data={profile.engineerId} />
            <BlockField name="Статус сотрудника" data={profile.engineerStatus} />
            <BlockField name="Тип сотрудника" data={profile.engineerType} />
            {profile.tests && profile.tests.questions ? profile.tests.questions.map(function(item, i){
              var idSelect,
                  typeAnswer = false,
                  typeSkillAsker = false,
                  rightAnswer = false;

              {/* console.log(item); */}
              for (var i2 = 0, l = item.answers.length; i2 < l; i2++) {
                if(item.answers[i2].select){
                  idSelect = i2;
                  if(item.answers[i2].type){
                    typeAnswer = true;
                  }
                }
                if(item.answers[i2].balls){
                  for(var itemB of item.answers[i2].balls){
                    if(itemB.skillId == askerId){
                      typeSkillAsker = true;
                      if(idSelect == i2){
                        rightAnswer = true;
                      }
                    }
                  }
                }
                
              }
              if(typeSkillAsker){
                return(
                  <div className="blockField vert" style={{borderColor: rightAnswer ? '#00cc00' : '#ff0000'}} key={i}>
                    <div className="nameField">{item.question}</div>
                    <div className="dataField">{typeof idSelect == 'undefined' ? '' : item.answers[idSelect].name}</div>
                  </div>
                );
              }

            }) : null}
            {profile.categoriesTest && profile.tests ? <BlockField type="uniteField" link={this.props.location + "tests/"} data="Результаты теста" /> : ''}
            {profile.historyStatus ? <BlockField type="uniteField" link={this.props.location + "statuses/"} data="История статуса" /> : ''}
            <BlockStatus status1C={status1C} resStatus1C={profile.resStatus1C} status={status} actionChange={this.handlerChangeStatus} />
            <BlockField type="uniteField" link={"/admin/specialty/" + this.props.specialty + "/"} data="Назад" />
        </div>
      );
    }else{
      return(
        <div className="loading"></div>
      );
    }
  }
});

export default Profile;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Profile/index.jsx
 **/